import React from 'react';
import { useApp } from '../context/AppContext';
import { useT } from '../i18n/translations';
import Icon from './Icon';
import './GameCard.css';

export default function GameCard({ product }) {
  const { lang, navigate, fx, wishlist, dispatch, addToCart } = useApp();
  const t = useT(lang);
  void t;
  const wished = wishlist.includes(product.id);

  const cheapest = product.denominations[0];
  const headline = product.denominations[Math.min(2, product.denominations.length - 1)];

  return (
    <article
      className="gc"
      style={{ '--gc-bg': product.bg }}
      onClick={() => navigate('product', { id: product.id })}
    >
      <div className="gc__media">
        <div
          className="gc__photo"
          style={{ backgroundImage: product.image ? `url(${product.image})` : 'none' }}
        />
        <div className="gc__overlay" />
        <div className="gc__brand-chip" style={{ background: product.bg }}>
          {product.logoUrl ? (
            <img
              src={product.logoUrl}
              alt={product.en || product.name}
              loading="lazy"
            />
          ) : (
            <span>{product.logoText || product.en}</span>
          )}
        </div>
        <div className="gc__badges">
          {product.discount && (
            <span className="badge badge-discount">−{product.discount}%</span>
          )}
          {product.new && <span className="badge badge-new">NEW</span>}
          {product.hot && <span className="badge badge-hot">HOT</span>}
        </div>
        <button
          className={`gc__wish ${wished ? 'is-active' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            dispatch({ type: 'TOGGLE_WISH', id: product.id });
          }}
          aria-label="Wishlist"
        >
          <Icon name={wished ? 'heartFilled' : 'heart'} size={14} />
        </button>
      </div>

      <div className="gc__body">
        <div className="gc__publisher">{product.publisher}</div>
        <h3 className="gc__name">{product.name}</h3>
        <div className="gc__meta">
          <span className="gc__metaitem">
            <Icon name="bolt" size={11} />
            即時發卡
          </span>
          <span className="gc__sep">·</span>
          <span className="gc__metaitem">
            <Icon name="globe" size={11} />
            {product.region}
          </span>
        </div>
        <div className="gc__footer">
          <div className="gc__price">
            <span className="gc__price-from">起</span>
            <span className="gc__price-num">{fx(cheapest.price)}</span>
          </div>
          <button
            className="gc__cta"
            onClick={(e) => {
              e.stopPropagation();
              addToCart(
                {
                  productId: product.id,
                  denomKey: headline.points + '-' + (headline.label || ''),
                  name: `${product.name} · ${headline.label || headline.points}`,
                  color: product.bg,
                  price: headline.price,
                  qty: 1,
                  meta: headline,
                },
                product.name
              );
            }}
            aria-label={t.cta.addCart}
          >
            <Icon name="plus" size={14} />
          </button>
        </div>
      </div>
    </article>
  );
}
